<template>    
    <v-list-tile>
        <v-list-tile-content>
            <v-list-tile-title v-html="item.nome_utente"></v-list-tile-title>
            <v-list-tile-sub-title>
                <div v-if="item.id_mensile">
                    <v-btn 
                    flat icon small
                    @click.stop="fileClickHandler('MENSILE', protocollatoMensile)"
                    :color="!protocollatoMensile ? 'pink' : 'blue'"
                    ><v-icon>fas fa-file-pdf</v-icon></v-btn>
                    Mensile {{ item.totale_current || '0.00' }} €
                </div>
                <div v-if="item.id_integrato">
                    <v-btn 
                    flat icon small
                    @click.stop="fileClickHandler('INTEGRATO', protocollatoIntegrato)"
                    :color="!protocollatoIntegrato ? 'pink' : 'blue'"
                    ><v-icon>fas fa-file-pdf</v-icon></v-btn>
                    Integrazione {{ item.totale_integrato || '0.00' }} €      
                </div>
            </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
            <v-list-tile-action-text class="headline">{{item.totale || '0.00'}} €</v-list-tile-action-text>
        </v-list-tile-action>
    </v-list-tile>
</template>

<script>

export default {
  name: "acc-report-note-dettaglio-item",
  components: {},
  props: {
    item: {
      type: Object
    },
  },
  data: () => ({
    imgPrev: false
  }),
  computed: {
      protocollatoMensile() {
          return Boolean(+this.item.protocolato_mensile)
      },
      protocollatoIntegrato() {
          return Boolean(+this.item.protocolato_integrato)
      }
  },
  watch: {},
  methods: {
    showImgPrew() {
      this.imgPrev = true;
    },
    closeImgPrewHandler() {
      this.imgPrev = false;
    },
    fileClickHandler(type, protocollata) {
        const data = {};
        const mensile = type === 'MENSILE';
        
        data.protocollata = protocollata;
        data.spesa_id = mensile ? this.item.id_mensile : this.item.id_integrato;
        data.protocolName = mensile ? this.item.nome_protocollo_mensile : this.item.nome_protocollo_integrato;
        data.file = this.$store.getters.getPageData.protocolPath + data.protocolName;
        
        this.$emit('on-click-protocollare', data)
    },
  }
};
</script>

<style lang="scss">
.modal-image-prewiev__wrap-content {
  height: calc(100% - 64px);
  modal-image-prewiev__content {
    height: 100%;
    img {
      display: block;
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/ReportRowItem.vue